import { defaultPaymentDetails, paymentTypeFields } from '../../constant';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { formatDate, formatTimeIST } from '../../helper';
import { PaymentFieldKeys, PaymentModeType } from '../../../constants';
import { CreatePaymentTransactionRequest } from '@zonofi/zono-money-store';

export const mapOfflinePaymentDetails = (
  paymentData: CreatePaymentTransactionRequest
) => {
  if (!paymentData) return [];
  const modeKey =
    paymentData.paymentMode?.toUpperCase() as keyof typeof PaymentModeType;

  const mode =
    (PaymentModeType[modeKey] as PaymentModeType) || paymentData.paymentMode;

  const additionalFields =
    mode && paymentTypeFields[mode] ? paymentTypeFields[mode] : [];

  const fields = [...defaultPaymentDetails, ...additionalFields];

  return fields.map((field) => {
    const responseKey = Object.keys(paymentData).find(
      (key) => key.toLowerCase() === field.key.toLowerCase()
    );

    let value =
      field.key === PaymentFieldKeys.PAYMENT_TIME
        ? formatTimeIST(paymentData.paymentDate)
        : responseKey
          ? paymentData[responseKey as keyof CreatePaymentTransactionRequest]
          : '';

    switch (field.key) {
      case PaymentFieldKeys.PAYMENT_MODE:
        value = mode || '';
        break;

      case PaymentFieldKeys.AMOUNT_PAID: {
        const amount = typeof value === 'number' ? value : Number(value);
        value = !isNaN(amount) ? getFormattedAmount(amount, true) : '';
        break;
      }

      case PaymentFieldKeys.PAYMENT_DATE:
        value = value ? formatDate(value) : '';
        break;

      case PaymentFieldKeys.PAYMENT_REFERENCE_CODE:
        value = value || '';
        break;
    }

    return {
      key: field.key,
      label: field.label,
      value: value != null ? String(value) : '',
    };
  });
};
